const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    DOMAIN_NAME: process.env.REACT_APP_DOMAIN_NAME,
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || '/',
    DOCUMENT_URL: `${process.env.REACT_APP_API_BASE_URL}document/`,
    WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
}

export default config;